export enum OrderSource {
    PURCHASE = "purchase",
    GIFT = "gift",
};